<template>
    <div class="wrapper">
        <SelectBox
            :placeholder="$t('reporting.commonLabels.period')"
            :value="value"
            :options="periods"
            @input="$emit('input', $event)"
        />
    </div>
</template>

<script>
import SelectBox from './../../../common/SelectBox.vue';
import { periods as periodsArray, translateOptions } from '../../widgetHelpers';

export default {
    components: { SelectBox },

    props: {
        value: {
            type: Number,
            required: true,
        },
    },

    computed: {
        /**
         * Returns a list of options for periods dropdown
         * {{ name: string, value: number}[]}
         */
        periods() {
            return translateOptions(this.$t.bind(this), periodsArray);
        },
    },
};
</script>
